import { every, find, get, toPairs } from 'lodash';
import { PERMITTED_PERMISSIONS } from 'modules/common/constants/permisssionsTypes';
import { userPermissionsResources } from 'modules/appointmentsManagement/selectors/users';

const checkUserPermission = (state, neededPermissions) => {
  const [resourceCode, properties] = toPairs(neededPermissions)[0];
  const roleResources = get(state, 'auth.userInfo.dynamicPermissions.roleResources', []);
  const resource = find(roleResources, { resourceCode });

  return every(properties, property => PERMITTED_PERMISSIONS.includes(get(resource, property)));
};

export const getUsersReadPermissions = state => {
  const userModulePermissions = checkUserPermission(state, { [userPermissionsResources.USERS]: ['read'] });
  const userDetailsPermissions = checkUserPermission(state, { [userPermissionsResources.USERS_DETAILS]: ['read'] });

  return {
    canSeeUserAccount: userModulePermissions,
    canSeeUserData: userModulePermissions,
    canSeePolicyId: userDetailsPermissions,
    canSeeName: userDetailsPermissions,
    canSeeGender: userDetailsPermissions,
    canSeeBirthDate: userDetailsPermissions,
    canSeeEmail: userDetailsPermissions,
    canSeePhone: userDetailsPermissions,
    canSeeAddress: userDetailsPermissions,
    canSeeDescription: userDetailsPermissions,
    canSeeAvatar: userDetailsPermissions,
  };
};

export const getUsersUpdatePermissions = state => {
  const userModulePermissions = checkUserPermission(state, { [userPermissionsResources.USERS]: ['update'] });
  const userDetailsPermissions = checkUserPermission(state, { [userPermissionsResources.USERS_DETAILS]: ['update'] });

  return {
    canUpdateUserAccount: userModulePermissions,
    canUpdateUserData: userDetailsPermissions,
    canUpdatePolicyId: false,
    canUpdateName: userDetailsPermissions,
    canUpdateGender: userDetailsPermissions,
    canUpdateBirthDate: userDetailsPermissions,
    canUpdateEmail: userDetailsPermissions,
    canUpdatePhone: userDetailsPermissions,
    canUpdateAdditionalPhone: userDetailsPermissions,
    canUpdateAddress: userDetailsPermissions,
    canUpdateDescription: userDetailsPermissions,
    canUpdateAvatar: userDetailsPermissions,
  };
};
